export function asNullableBool(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  if (value === true || value === 1 || value === "1" || value === "true") {
    return true;
  }
  if (value === false || value === 0 || value === "0" || value === "false") {
    return false;
  }
  return null;
}

export function effectiveSetting(override, ownerValue, fallback) {
  const own = asNullableBool(override);
  if (own !== null) {
    return own;
  }
  const inherited = asNullableBool(ownerValue);
  if (inherited !== null) {
    return inherited;
  }
  return fallback;
}

export function loanableAllowsDeclaredExpenses(loanable) {
  if (!loanable) {
    return false;
  }
  return effectiveSetting(
    loanable.allows_declared_expenses,
    loanable.owner && loanable.owner.allows_declared_expenses,
    true
  );
}

export function someLoanableAllowsDeclaredExpenses(loanables) {
  return (loanables || []).some(loanableAllowsDeclaredExpenses);
}
